// @flow

import fetch from 'node-fetch';
import { compose, lifecycle, withStateHandlers, type HOC } from 'recompose';

export type WithTeamProps = {
  fetched: boolean,
  teamDisplayName: string,
  teamName: string
};

export default (compose(
  withStateHandlers(
    {
      fetched: false,
      teamDisplayName: '',
      teamName: ''
    },
    {
      showTeamName: () => ({ teamDisplayName, teamName }: WithTeamProps) => ({
        fetched: true,
        teamDisplayName,
        teamName
      })
    }
  ),
  lifecycle({
    componentDidMount() {
      return fetch(`/api`)
        .then(res => res.json())
        .then(({ teamName, displayName }) => {
          this.props.showTeamName({
            teamDisplayName: displayName || teamName,
            teamName
          });
        });
    }
  })
): HOC<*, Object>);
